import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import Header from "./Header";
import Policy from "./page/Policy";
import Footer from "./Footer";
import Support from "./page/Support";
import Home from "./page/Home";
import TestMap from "./page/TestMap";

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <Routes>
          <Route element={<Home />} path=""></Route>

          <Route
            element={<Policy />}
            path="2023/02/07/hivex-data-management-and-policy/"
          ></Route>
          <Route
            element={<Policy />}
            path="hivex-data-management-and-policy/"
          ></Route>

          <Route element={<TestMap />} path="test-map"></Route>
          <Route
            element={<Support />}
            path="hivex_issuer_customersupport/PP"
          ></Route>

          <Route
            path="*"
            element={
              <main style={{ padding: "1rem" }}>
                <p>There's nothing here!</p>
              </main>
            }
          />
        </Routes>
      </Router>
      <Footer />
    </div>
  );
}
export default App;
